import { render, staticRenderFns } from "./shop-form-dialog.app.vue?vue&type=template&id=ec03ea78&"
import script from "./shop-form-dialog.app.vue?vue&type=script&lang=js&"
export * from "./shop-form-dialog.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports